'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Featured;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Featured(_ref) {
  var events = _ref.events;

  return _react2.default.createElement(
    'div',
    { className: 'Featured' },
    _react2.default.createElement(_caligramReact.EventList, { events: events, groupBy: 'none', layout: 'grid', columns: 8, dateFormat: 'Do MMMM' })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Featured.js
// module id = 1113
// module chunks = 0